import styled from 'styled-components'
import { Heading, theme } from '@notino/react-styleguide'

// components
import DefaultContainer from '../../components/DefaultContainer/DefaultContainer'

// styles
import { BREAKPOINTS } from '../../styles/constants'
import { NotinoTitleMedium, NotinoTitleSmall } from '../../styles/helpers'

export const PageContainer = styled(DefaultContainer)`
	position: relative;
`

export const MainTitle = styled(Heading.H1)`
	font-weight: 500;
	margin-top: 4px;
	margin-bottom: 16px;
	text-align: left !important; // override for notino global styles
`

export const MainContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;

	@media (min-width: ${BREAKPOINTS.sm}) {
		gap: 40px;
	}
`

export const PassesSection = styled.section`
	&:focus {
		outline: none;
	}
`

export const SubTitle = styled(Heading.H2)`
	${NotinoTitleSmall};
	margin-top: 0;
	margin-bottom: 10px;
	text-align: left !important; // override for notino global styles
	color: ${theme.color.text.primary};

	@media (min-width: ${BREAKPOINTS.sm}) {
		${NotinoTitleMedium};
		padding: 4px 0;
		margin-bottom: 20px;
		line-height: 1.875rem;
	}
`
